import React from "react";
import PropTypes from "prop-types";
import "./ErrorMessage.css"

function ErrorMessage(props) {
    return <div className="ErrorMessage">
        <div className="icon">😬</div>
        <div className="error">
            {props.message}
        </div>
    </div>
}
ErrorMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ErrorMessage;
